import { render, staticRenderFns } from "./socialResponsibilityDetail.vue?vue&type=template&id=06f50ae4&scoped=true&"
import script from "./socialResponsibilityDetail.vue?vue&type=script&lang=js&"
export * from "./socialResponsibilityDetail.vue?vue&type=script&lang=js&"
import style0 from "./socialResponsibilityDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./socialResponsibilityDetail.vue?vue&type=style&index=1&id=06f50ae4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f50ae4",
  null
  
)

export default component.exports